import { css } from '@/styled-system/css';

export const printHidden = css.raw({
  '@media print': {
    display: 'none',
  },
});

export const printOnly = css.raw({
  display: 'none',
  '@media print': {
    display: 'block',
  },
});
